/* eslint-disable import/imports-first */
// NOTE: include React lib in main.js. the chunks is for react component and logic only
import React from 'react'; // eslint-disable-line no-unused-vars
import ReactDOM from 'react-dom'; // eslint-disable-line no-unused-vars

require('imports!bootstrap/js/button'); // bootstrap/js/button
require('imports!bootstrap/js/collapse'); // bootstrap/js/collapse
require('imports!bootstrap/js/dropdown'); // bootstrap/js/dropdown
require('imports!bootstrap/js/tab'); // bootstrap/js/dropdown
require('dustjs-helpers');
require('utils/dustjs-custom-helpers');
const $ = require('jquery');

import configCMSDirectioApp from 'configPage/configCMSDirectioApp';
import configContattiPage from 'configPage/contatti';
import configHomepage from 'configPage/homepage';
import configSearchPage from 'configPage/search';
// Utils
import setupGetParameters from 'utils/setupGetParameters';
import setupSearchbox from 'utils/setupSearchbox';
import syncHeightWrapper from 'utils/syncHeightWrapper';
import * as variables from 'variables';

const multidirectio = {
	common: {
		init() {
			setupGetParameters();
			global._monthNames = variables._monthNames || [];
			global._monthShortNames = variables._monthShortNames || [];
			syncHeightWrapper();
			setupSearchbox();
		},
		finalize() {},
	},
	cmsDirectioApp: {
		init() {
			configCMSDirectioApp();
		},
	},
	contattiPage: {
		init() {
			configContattiPage();
		},
	},
	homepage: {
		init() {
			configHomepage();
		},
	},
	search: {
		init() {
			configSearchPage();
		},
	},
};

const UTIL = {
	fire(func, funcname = 'init') {
		const namespace = multidirectio;  // indicate your obj literal namespace here
		if (func !== '' && namespace[func] && typeof namespace[func][funcname] === 'function') {
			namespace[func][funcname]();
		}
	},
	loadEvents() {
		// hit up common first.
		UTIL.fire('common');
		const mainContent = document.getElementById('main-content');
		if (mainContent === 'undefined' || mainContent === null) {
			return;
		}
		const controller = mainContent.getAttribute('data-controller');
		if (controller !== '') {
			UTIL.fire(controller);
		}
		UTIL.fire('common', 'finalize');
	},
};

(() => {
	variables._monthNames = variables._monthNames || [];

	// Global ref
	variables.$window = $(window);
	variables.$doc = $(document);
	variables.$body = $('body');

	variables.$doc.ready(UTIL.loadEvents);
})();



/** WEBPACK FOOTER **
 ** ./scripts/main.js
 **/